import axios from "../plugins/axios";
// 导出数据
export const examineExportListAll = (param) => {
  return axios({
    method: "get",
    responseType: "blob",
    url: "/course/lessonRecord/exportOrders?encryptPhone=" + param.encryptPhone,
  });
};
